export default __webpack_public_path__ + "static/media/I_Old_Black.898ec271.png";